import { Phone } from "lucide-react";
import { BUSINESS, telHref } from "../lib/business";

export const Navbar = () => {
    return (
        <header
            data-testid="site-navbar"
            className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="navbar-logo"
                    className="flex items-center gap-2 group"
                >
                    <span className="relative flex items-center justify-center w-9 h-9 rounded-lg bg-[#0055FF] text-white font-black text-lg shadow-[0_6px_16px_-6px_rgba(0,85,255,0.6)]">
                        K
                        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-[#25D366] live-dot ring-2 ring-white" />
                    </span>
                    <div className="leading-tight">
                        <div className="font-extrabold tracking-tight text-slate-900 text-[15px]">
                            {BUSINESS.name}
                        </div>
                        <div className="text-[11px] font-semibold uppercase tracking-widest text-[#0055FF]">
                            7/24 Aktif
                        </div>
                    </div>
                </a>

                <nav className="hidden md:flex items-center gap-7 text-sm font-semibold text-slate-700">
                    <a href="#hizmetler" data-testid="nav-hizmetler" className="hover:text-[#0055FF] transition-colors">Hizmetler</a>
                    <a href="#hakkinda" data-testid="nav-hakkinda" className="hover:text-[#0055FF] transition-colors">Hakkımızda</a>
                    <a href="#bolgeler" data-testid="nav-bolgeler" className="hover:text-[#0055FF] transition-colors">Bölgeler</a>
                    <a href="#sss" data-testid="nav-sss" className="hover:text-[#0055FF] transition-colors">SSS</a>
                    <a href="#iletisim" data-testid="nav-iletisim" className="hover:text-[#0055FF] transition-colors">İletişim</a>
                </nav>

                <a
                    href={telHref}
                    data-testid="navbar-call-btn"
                    className="inline-flex items-center gap-2 rounded-full bg-[#FF3B30] hover:bg-[#E6352B] text-white px-4 py-2 text-sm font-bold shadow-[0_8px_20px_-8px_rgba(255,59,48,0.7)] transition-all hover:scale-[1.03] active:scale-95"
                >
                    <Phone className="w-4 h-4" strokeWidth={2.5} />
                    <span className="hidden sm:inline">Hemen Ara</span>
                    <span className="sm:hidden">Ara</span>
                </a>
            </div>
        </header>
    );
};

export default Navbar;
